import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[app-slider-link]',
})
export class SliderLinkDirective implements OnInit {
  private el = inject(ElementRef);

  setStyles(element: HTMLElement): void {
    element.style.cursor = 'pointer';
  }

  ngOnInit(): void {
    this.setStyles(this.el.nativeElement);
  }
}
